import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import { browserHistory } from 'react-router/es';
import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import { refreshMiddleware } from 'middleware/refresh-middleware';
import { persistStore } from 'redux-persist';
import rootReducer from 'reducers';

const persistConfig = {
  whitelist: ['app', 'userBrands', 'workflows', 'design', 'menuAnalysis', 'orderGuide'],
};

const router = routerMiddleware(browserHistory);

const enhancer = compose(
  applyMiddleware(refreshMiddleware, createDebounce(), thunk, router)
);

export default function configureStore(initialState) {
  const store = createStore(rootReducer, initialState, enhancer);
  persistStore(store, persistConfig);
  return store;
}
